/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldType } from './FieldType';
import {
    FieldTypeFromJSON,
    FieldTypeFromJSONTyped,
    FieldTypeToJSON,
    FieldTypeToJSONTyped,
} from './FieldType';

/**
 * 
 * @export
 * @interface FieldConfig
 */
export interface FieldConfig {
    /**
     * 
     * @type {FieldType}
     * @memberof FieldConfig
     */
    fieldType: FieldType;
    /**
     * 
     * @type {string}
     * @memberof FieldConfig
     */
    label: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldConfig
     */
    options?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FieldConfig
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FieldConfig
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldConfig
     */
    saveRunningValues?: boolean;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof FieldConfig
     */
    runningValues?: { [key: string]: Array<string>; };
    /**
     * Per-game running values - tracks unique values seen per game per data source
     * @type {{ [key: string]: { [key: string]: Array<string>; }; }}
     * @memberof FieldConfig
     */
    runningValuesByGame?: { [key: string]: { [key: string]: Array<string>; }; };
    /**
     * Maps raw values to normalized canonical values
     * @type {{ [key: string]: string; }}
     * @memberof FieldConfig
     */
    valueMappings?: { [key: string]: string; };
    /**
     * List of unique normalized values after applying valueMappings
     * @type {Array<string>}
     * @memberof FieldConfig
     */
    canonicalValues?: Array<string>;
}



/**
 * Check if a given object implements the FieldConfig interface.
 */
export function instanceOfFieldConfig(value: object): value is FieldConfig {
    if (!('fieldType' in value) || value['fieldType'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function FieldConfigFromJSON(json: any): FieldConfig {
    return FieldConfigFromJSONTyped(json, false);
}

export function FieldConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldType': FieldTypeFromJSON(json['fieldType']),
        'label': json['label'],
        'options': json['options'] == null ? undefined : json['options'],
        'description': json['description'] == null ? undefined : json['description'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'saveRunningValues': json['saveRunningValues'] == null ? undefined : json['saveRunningValues'],
        'runningValues': json['runningValues'] == null ? undefined : json['runningValues'],
        'runningValuesByGame': json['runningValuesByGame'] == null ? undefined : json['runningValuesByGame'],
        'valueMappings': json['valueMappings'] == null ? undefined : json['valueMappings'],
        'canonicalValues': json['canonicalValues'] == null ? undefined : json['canonicalValues'],
    };
}

export function FieldConfigToJSON(json: any): FieldConfig {
    return FieldConfigToJSONTyped(json, false);
}

export function FieldConfigToJSONTyped(value?: FieldConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fieldType': FieldTypeToJSON(value['fieldType']),
        'label': value['label'],
        'options': value['options'],
        'description': value['description'],
        'isRequired': value['isRequired'],
        'saveRunningValues': value['saveRunningValues'],
        'runningValues': value['runningValues'],
        'runningValuesByGame': value['runningValuesByGame'],
        'valueMappings': value['valueMappings'],
        'canonicalValues': value['canonicalValues'],
    };
}

